<template>
  <CCard>
    <CCardBody>
      <h5 class="text-primary">Application Status</h5>
      <BasicBar :data="applicationStatusChartData" :height="300" />
    </CCardBody>
  </CCard>
</template>
<script>
import BasicBar from "@/components/reusable/Charts/BasicBar.vue";
import clinicalData from "@/containers/ClinicalPlacementDashboard/clinicalData.json";
export default {
    name: "ApplicationStatusChart",
    components: {
        BasicBar,
    },
    computed: {
        applicationStatusChartData() {
            const count = clinicalData.reduce((acc, item) => {
                if (!acc[item["Application Status"]] ) {
                    acc[item["Application Status"]] = 0;
                }
                acc[item["Application Status"]]++;
                return acc;
            }, {});
            const counts = Object.entries(count).map(([applicationStatus, count], index) => ({
                name: applicationStatus,
                value: count
            }));
            return [
                {
                    name: "Application Status",
                    backgroundColor: "#b1a5d6",
                    borderColor: "#b1a5d6",
                    values: counts,
                }
            ];
        },
        
    }
};
</script>
